export default {
  cookieBanner: {
    visible: true,
    url: null,
  },
  personalizedAds: true,
};



// WEBPACK FOOTER //
// ./app/Gdpr/initialState.js